
import SharedContentListContainer from 'containers/SharedContentContainer/SharedContentListContainer';

export const SharedHypothesesListScreen = () => (
  <SharedContentListContainer listType="hypotheses" />
);

export default SharedHypothesesListScreen;
